import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { actions as composerPopoverActions } from '~/composer-popover';
import { useSentPostActions } from '~/post/hooks/useSentPostActions';
import { PublishingPost } from '~/post/types.generated';
import CreateCalendarPostContext from '../../hooks/createCalendarPostContext';
import { ButtonStyled } from './styles';

export const SentPostActions = ({ post }: { post: PublishingPost }) => {
  const dispatch = useDispatch();
  const { selectedProfileIds } = useContext(CreateCalendarPostContext);

  const onShareLinkClick = () => {
    dispatch(
      composerPopoverActions.handleShareLinkClick(post, selectedProfileIds)
    );
  };

  const onShareAgainClick = () => {
    dispatch(composerPopoverActions.handleShareAgainClick(post.id));
  };

  const { stackedActions } = useSentPostActions({
    post,
    onShareLinkClick,
    onShareAgainClick,
  });

  const [firstAction, ...restStackedActions] = stackedActions;
  const executeStackedActions = ({ id }) => {
    const selectedAction = stackedActions.find((action) => action.id === id);
    if (selectedAction) selectedAction.callback();
  };

  return (
    <ButtonStyled
      size="small"
      type="secondary"
      isSplit={!!restStackedActions}
      items={restStackedActions}
      label={firstAction.title}
      onClick={firstAction.callback}
      onSelectClick={executeStackedActions}
    />
  );
};
